import { call, put } from "redux-saga/effects";

import * as API from "../../../Connections/APIs/MicroHub";
import * as Action from "../../Actions/MicroHubs/Actions";

export function* getHubsSaga(action) {
  try {
    const response = yield call(API.getAllHubsApi, action.data);
    yield put(Action.getHubsSuccessAction(response.data, action.data?.planId));
  } catch (error) {
    yield put(Action.getHubsFailAction(error));
  }
};

export function* createHubSaga(action) {
  try {
    const response = yield call(API.createHubApi, action.data);
    yield put(Action.createHubSuccessAction(response.data));
  } catch (error) {
    yield put(Action.createHubFailAction(error));
  }
};

export function* editHubSaga(action) {
  try {
    const response = yield call(API.editHubApi, action.data);
    yield put(Action.editHubSuccessAction(response.data));
  } catch (error) {
    yield put(Action.editHubFailAction(error));
  }
};

export function* deleteHubSaga(action) {
  try {
    const response = yield call(API.deleteHubApi, action.data);
    yield put(Action.deleteHubSuccessAction(response.data));
  } catch (error) {
    yield put(Action.deleteHubFailAction(error));
  }
};

export function* getHubByIdSaga(action) {
  try {
    const response = yield call(API.getHubByIdApi, action.data);
    yield put(Action.getHubByIdSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getHubByIdFailAction(error));
  }
};

export function* assignPolygonToHubSaga(action) {
  try {
    const response = yield call(API.assignPolygonToHubApi, action.data);
    yield put(Action.assignPolygonToHubSuccessAction(response.data));
  } catch (error) {
    yield put(Action.assignPolygonToHubFailAction(error));
  }
};

export function* removeHubFromPolygonSaga(action) {
  try {
    const response = yield call(API.removeHubFromPolygonApi, action.data);
    yield put(Action.removeHubFromPolygonSuccessAction(response.data));
  } catch (error) {
    yield put(Action.removeHubFromPolygonFailAction(error));
  }
};